




























































import { Vue, Component } from "../vue-ext";
import { LeavingNotice, HousingCompany, Apartment, SignatureType, Account } from "../models";

@Component
export default class LeavingNoticeView extends Vue {
    private leavingNotice: LeavingNotice = {} as LeavingNotice;
    private housingCompany: HousingCompany | null = null;
    private account: Account | null = null;
    private apartment: Apartment | null = null;
    private signatureTypeList: SignatureType[] = [SignatureType.Application];
    private noticeSentSuccessfully: boolean = false;

    private async created() {
        this.root.setTitle(this.$t("menu.leavingNotice") as string);
        this.root.setIconClass("icon-lahtoilmoitukset");

        const housingCompanyId = parseInt(this.$route.params.housingCompanyId, 10);
        const accountId = parseInt(this.$route.params.accountId, 10);
        const apartmentId = parseInt(this.$route.params.apartmentId, 10);

        if (accountId) {
            this.leavingNotice.accountId = accountId;
        }

        if (apartmentId) {
            this.leavingNotice.apartmentId = apartmentId;
        }

        this.housingCompany = await this.root.service.housingCompany.Get(housingCompanyId);
        this.account = await this.root.service.user.GetAccount(accountId) as any;
        this.apartment = await this.root.service.housingCompany.GetApartment(housingCompanyId, apartmentId);

        if (!this.housingCompany) {
            this.$router.back();
            return;
        }

        this.leavingNotice.signatureType = SignatureType.Application;
    }

    private async save() {
        const res = await this.root.service.notice.SendLeavingNotice(this.leavingNotice);

        if (!res.isError) {
            this.noticeSentSuccessfully = true;
        }
    }
}
